export default __webpack_public_path__ + "static/media/micro_bell_notification.eb26141f.mp3";